<template>
  <div class="bg" :style="{ background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header></home-header>
    <div class="bgbody">
      <div class="center">
        <div class="header">{{ meetingName }}正在签到中！</div>
        <div class="registerCon">
          <div class="boxCon">
            <div class="imgBox" id="canvasBox">
              <video
                id="webcam"
                width="100%"
                height="100%"
                ref="videoDom"
                preload
                autoplay
                loop
                muted
                v-show="bol"
              ></video>
              <canvas ref="canvasDOM" id="face_detect"></canvas>
              <canvas
                style="display: none"
                class="faceImgcanvas"
                id="faceImgcanvas"
              ></canvas>
              <!-- <div id="rectbox" ref="capture"></div> -->
            </div>
            <div class="imgtext">{{ isdetected }}</div>
          </div>
          <div class="boxCon">
            <div class="imgBox">
              <video
                id="qrcode"
                width="100%"
                height="100%"
                ref="videoCode"
                preload
                autoplay
                loop
                muted
                v-show="bol1"
              ></video>
              <canvas ref="qrcodeDOM" id="qrcode_detect"></canvas>
              <!-- <div class="qrcode" ref="qrCodeUrl">
                        </div>
                        <img id="faceImg" style="display:none;" class="faceImg" :src="imgSrc" alt=""> -->
            </div>
            <div class="imgtext">请扫描二维码签到</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import { allLists, saveToImgByStr } from "@/utils/request";
import QRCode from "qrcodejs2";

export default {
  name: "register",
  components: {
    HomeHeader,
  },
  data() {
    return {
      video: null,
      bol: true,
      bol1: true,
      meetingId: "",
      meetingName: "",
      timer: null,
      startTime: "",
      thisCodeId: "",
      faceImg: "",
      count: 0,
      count2: 0,
      imgSrc: "",
      isdetected: "请对准需要识别的人脸",
      videoEl: {},
      canvasEL: {},
      trackCcv: false,
      trackTracking: false,
      autoCaptureTrackTraking: false,
      rect: {},
      isAready: false,
      isShowQcode: true,
      erweimaId: "",
      tracker: null,
      trackTask: null,
      userMediaConstraints: {
        audio: false,
        video: {
          // 摄像头翻转
          facingMode: "user",
        },
      },
      bgUrl:''
    };
  },
  // watch: {
  //     isAready: function (val,oldVal) {
  //         console.log(val,oldVal)
  //         if(val){
  //             console.log(111)
  //             this.tracker.stop()
  //         }
  //     }
  // },
  methods: {
    // 会议室信息列表
    allLists() {
      // console.log(this.$route)
      let params = {
        meetingId: this.meetingId,
      };
      allLists(params).then((res) => {
        // console.log(res)
        if (res.code == 0) {
          this.startTime = res.data.pageInfoList.list[0].startTime;
          this.erweimaId = res.data.pageInfoList.list[0].id;
          if (this.isShowQcode) {
            this.creatQrCode(res.data.pageInfoList.list[0].id);
          }
          if (
            this.$route.query.homeTo &&
            this.$route.query.homeTo !== undefined
          ) {
            let _this = this;
            this.timer = setInterval(() => {
              let curdate = new Date().getTime();
              // console.log(curdate)
              let startSeconds = new Date(this.startTime).getTime();
              if (startSeconds < curdate) {
                //会议开始了
                clearInterval(_this.timer);
                _this.$router.push({
                  path: "/advertising",
                  query: {
                    equipmentName: this.equipmentName,
                    meetingId: this.meetingId,
                    name: this.name,
                    meetingName: this.meetingName,
                  },
                });
              }
            }, 1000);
          }
        }
      });
    },
    creatQrCode(id) {
      // console.log(document.getElementsByClassName('imgBox')[1].clientWidth)
      let w = document.getElementsByClassName("imgBox")[1].clientWidth;
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: id, // 需要转换为二维码的内容
        width: w * 0.6,
        height: w * 0.6,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    async init() {
      let w = document.getElementsByClassName("imgBox")[1].clientWidth;
      let faceCanvas = document.getElementById("faceImgcanvas");
      let facecxt = faceCanvas.getContext("2d");
      let qrcodeCanvas = document.getElementById("qrcode_detect");
      let qrcodecxt = qrcodeCanvas.getContext("2d");
      this.videoEl = this.$refs.videoDom;
      this.videocodeEl = this.$refs.videoCode;
      this.videoEl.width = w * 0.7;
      this.videoEl.height = w * 0.7;
      this.videocodeEl.width = w * 0.7;
      this.videocodeEl.height = w * 0.7;
      faceCanvas.width = w * 0.7;
      faceCanvas.height = w * 0.7;
      qrcodeCanvas.width = w * 0.7;
      qrcodeCanvas.height = w * 0.7;
      this.canvasEL = this.$refs.canvasDOM;
      // navigator.mediaDevices.enumerateDevices()
      // .then(gotDevices).catch(handleError);
      await navigator.mediaDevices
        .getUserMedia(this.userMediaConstraints)
        .then(this.getMediaStreamSuccess)
        .catch(this.getMediaStreamError);
      await this.onPlay();
    },
    async onPlay() {
      // debugHelper.log('onPlay')
      this.isdetected = "请对准需要识别的人脸";
      this.onTrackTracking();
    },
    onTrackTracking() {
      const context = this;
      const video = this.videoEl;
      const canvas = this.canvasEL;
      const canvasContext = canvas.getContext("2d");
      const tracker = new tracking.ObjectTracker("face");
      video.src = "";
      tracker.setInitialScale(4);
      tracker.setStepSize(2);
      tracker.setEdgesDensity(0.1);
      tracking.track("#webcam", tracker, { camera: true });
      tracker.on("track", function (event) {
        // console.log(event)
        const { autoCaptureTrackTraking } = context;
        // canvasContext.clearRect(0, 0, canvas.width, canvas.height)
        event.data.forEach(function (rect) {
          console.log(rect);
          canvasContext.strokeStyle = "red";
          // console.log(rect.x, rect.y, rect.width, rect.height)
          canvasContext.clearRect(0, 0, canvas.width, canvas.height);
          context.plotRectangle(rect.x, rect.y, rect.width, rect.height);
        });
        // console.log(context.isAready)
        if (event.data.length > 0) {
          console.log(context.count);
          if (context.count < 0) context.count = 0;
          context.count += 1;

          if (context.count > 3) {
            context.saveToImgByStr(context.imgSrc);
          }
        } else {
          context.count -= 1;
          if (context.count < 0) context.isdetected = "请对准需要识别的人脸";
          //this.isdetected = '已检测到人脸'
        }
      });
    },
    checkisFace(img) {
      let imgFace = document.getElementById("faceImg");
      let _this = this;
      var tracker2 = new tracking.ObjectTracker("face");
      // console.log(imgFace.src)
      tracking.track(imgFace, tracker2);
      tracker2.on("track", function (event) {
        console.log(event);
        if (event.data.length > 0) {
          // if (_this.count2 < 0) _this.count2 = 0
          // _this.count2 += 1
          // if(_this.count2>1){
          console.log(img);
          _this.isdetected = "已检测到人脸";
          _this.saveToImgByStr(img);
          // }
        } else {
          // _this.count2 -= 1
          // if (_this.count2 < 0) _this.isdetected = '请对准需要识别的人脸'
          //this.isdetected = '已检测到人脸'
        }
      });
    },
    plotRectangle(x, y, w, h) {
      let canvasbox = document.getElementById("canvasBox");
      let iW = document.getElementsByClassName("imgBox")[1].clientWidth;
      // let rect = document.getElementById('rectbox')
      if (canvasbox.getElementsByTagName("div")[0]) {
        canvasbox.getElementsByTagName("div")[0].remove();
      }
      let rect = document.createElement("div");
      // let createCanvas = document.createElement('canvas')
      // let cxt = createCanvas.getContext('2d')
      // var videoElement = document.getElementById('webcam')
      let faceCanvas = document.getElementById("faceImgcanvas");
      let facecxt = faceCanvas.getContext("2d");
      // rect.classList.add('rectbox')
      const video = this.videoEl;
      canvasbox.appendChild(rect);
      console.log(x, y, w, h);
      // rect.setAttribute('ref','capture')
      rect.style.border = "5px solid red";
      rect.style.position = "absolute";
      rect.style.zIndex = "1000000";
      rect.style.width = w * 1.1 + "px";
      rect.style.height = h * 1.3 + "px";
      rect.style.left = video.offsetLeft / 2 + x * 0.65 + "px";
      rect.style.top = video.offsetTop / 2 + y * 0.9 + "px";

      facecxt.rect(x, y, w * 1.1, h * 1.3);
      facecxt.clip();
      facecxt.drawImage(video, 0, 0, video.width, video.height);

      let createCanvas = document.createElement("canvas");
      createCanvas.width = w * 1.1;
      createCanvas.height = w * 1.3;
      let cxt = createCanvas.getContext("2d");
      cxt.drawImage(
        faceCanvas,
        x,
        y,
        w * 1.5,
        h * 1.5,
        0,
        0,
        createCanvas.width,
        createCanvas.height
      );
      this.imgSrc = createCanvas.toDataURL("image/png");
    },
    getMediaStreamSuccess(stream) {
      // window.stream = stream // make stream available to browser console
      console.log(stream);
      this.videoEl.srcObject = stream;
      this.videocodeEl.srcObject = stream;
    },
    // 视频媒体流失败
    getMediaStreamError(error) {
      // alert('视频媒体流获取错误' + error)
    },
    //人脸识别接口
    saveToImgByStr(img) {
      const ImgData = {
        imgByte: img,
      };
      saveToImgByStr(ImgData)
        .then((res) => {
          // console.log(res)
          if (Number(res.code) === 0) {
            // this.$message.success('成功')
            this.count = 0;
            this.isdetected = "成功";
            setTimeout(() => {
              this.isdetected = "请对准需要识别的人脸";
            }, 1000);
            // this.isShowQcode = false
            // this.imgUrl = res.data
            this.imgSrc = "";
          } else {
            this.$message.error(res.data);
          }
        })
        .catch((err) => {
          this.isdetected = "连接失败";
          // this.onPlay()
        })
        .finally(() => {
          this.imgSrc = "";
        });
    },
  },
  mounted() {
    console.log(this.$route.query);
    this.bgUrl = localStorage.getItem('bgUrl')
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    //进入页面打开摄像头
    this.allLists();
    // if(this.timer){
    //     clearInterval(this.timer);
    // }else{
    //     this.timer = setInterval(() => {
    //         this.allLists()
    //     },10000)
    // }

    //人脸识别
    // The getUserMedia interface is used for handling camera input.
    // Some browsers need a prefix so here we're covering all the options
    navigator.getMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;
    this.init();
  },

  destroyed() {
    //退出页面关闭摄像头
    this.video.srcObject.getTracks()[0].stop();
    this.video.srcObject.getTracks()[0].closeCamera();
  },
};
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  height: 100%;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // padding: 6% 1s0%;
  font-size: 36px;
  .bgbody {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80%;
    margin-top: 20px;
    .center {
      width: 73%;
      height: 90%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.1);
      // min-height: 85%;
      .header {
        text-align: center;
        font-size: 48px;
        height: 14%;
        letter-spacing: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .registerCon {
        display: flex;
        height: 80%;
        .boxCon {
          position: relative;
          flex: 1;
        }
        .imgBox {
          text-align: center;
          position: relative;
          height: 80%;
          .qrcode {
            margin: 0 auto;
            padding: 5%;
            background: #fff;
            border-radius: 10px;
            width: 60%;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .faceImg {
            width: 100%;
            position: absolute;
            top: 20%;
            left: 0;
            transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
          }
          video {
            position: absolute;
            left: 50%;
            top: 0;
            transform: translate(-50%);
          }
          .faceImgcanvas {
            position: absolute;
            left: 50%;
            top: 0;
            transform: translate(-50%);
          }
          canvas {
            position: absolute;
            //  width: 75%;
            // height: 80%;
            left: 50%;
            top: 0;
            transform: translate(-50%);
            z-index: 111111;
          }
        }
        .imgtext {
          font-size: 36px;
          margin-top: 2%;
          // bottom: 12%;
          // left: 0;
          // position: absolute;
          width: 100%;
          text-align: center;
        }
      }
    }
  }
}
#webcam {
  object-fit: fill;
}
#qrcode {
  object-fit: fill;
}
</style>


// WEBPACK FOOTER //
// src/components/registerNew.vue